// extracted by mini-css-extract-plugin
export var calendarView = "_mg-0";
export var dayButton = "_mg-1";
export var dayCircle = "_mg-2";